import { ApiProperty } from "@nestjs/swagger";

export class UnitDateHourRequest {
    @ApiProperty()
    unit: string;
    @ApiProperty()
    date: string; // YYYY-MM-DD
    @ApiProperty()
    hour: number;
    @ApiProperty()
    lineId: string;
}